import { Component, OnInit, ViewChild, inject } from '@angular/core';
import { FormGroup, FormsModule } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogModule,
} from '@angular/material/dialog';
import { states } from '../../lib/states';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'app-create-profile-dialog',
  templateUrl: './create-profile-dialog.component.html',
  styleUrls: ['./create-profile-dialog.component.scss'],
  imports: [
    FormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatSelectModule,
    MatButtonModule,
    MatInputModule,
  ],
})
export class CreateProfileDialogComponent implements OnInit {
  dialogRef = inject<MatDialogRef<CreateProfileDialogComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);

  @ViewChild('profileForm', { static: true }) private form: FormGroup;

  modalData = {
    acctType: null,
    state: null,
    purpose: null,
  };
  annuity;
  rider;
  states = states;

  ngOnInit(): void {
    this.annuity = this.data.annuity;
    this.rider = this.data.rider;
    this.modalData.state = this.data.state;
  }

  cancel() {
    this.dialogRef.close({ data: 'cancel' });
  }

  save() {
    if (this.modalData.purpose && this.modalData.state) {
      this.dialogRef.close(this.modalData);
      this.dialogRef.afterClosed().subscribe(() => {
        this.dialogRef = null;
      });
    }
  }
}
